/** Datenlader der angemeldeten App fuer Panel-Bloecke (siehe components/widgets/widget-data.ts). */
import type { LoadWidgetData } from '../components/widgets/widget-data.js';

import { api, ApiError } from './api.js';
import { loadGeoFeaturesApp } from './geo-features-app.js';

export const loadWidgetDataApp: LoadWidgetData = async (source) => {
  try {
    if (source.type === 'geo_features' && source.dataset) return await loadGeoFeaturesApp(source.dataset, source.limit ?? 10000);
    if (source.type === 'sql_query' && source.query) return (await api.dataQuery(source.query)).rows;
    return [];
  } catch (err) {
    throw new Error(err instanceof ApiError ? `${err.code ?? 'error'}: ${err.message}` : err instanceof Error ? err.message : String(err));
  }
};
